/*
 * @Author: wangshengqiang
 * @Date: 2021-05-14 17:23:53
 * @LastEditTime: 2021-05-25 15:59:11
 * @LastEditors: wangshengqiang
 * @Description: 证件有效期选择控件
 */
import React from 'react';
import { Radio } from 'zarm';
import DateSelect from '../DateSelect';
import './index.less'; // placeholder
// onChange
// value

export default function CertValidity(props) {
  const {
    placeholder,
    value,
    onChange
  } = props;
  const longTermValue = '9999-12-31';
  const checked = value === longTermValue;
  const cdate = new Date().toLocaleDateString();
  return /*#__PURE__*/React.createElement("div", {
    className: "cert-validity"
  }, /*#__PURE__*/React.createElement(DateSelect, {
    className: "hair-line hair-line--r",
    title: "\u9009\u62E9\u65E5\u671F",
    placeholder: placeholder || '请选择证件有效期',
    mode: "date",
    min: cdate.replace('/', '-'),
    max: "2060-12-31",
    value: value,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "long-term",
    onClick: () => onChange(checked ? '' : longTermValue)
  }, /*#__PURE__*/React.createElement(Radio, {
    checked: checked
  }, "\u957F\u671F")));
}